import { render, staticRenderFns } from "./QuanLyThongTinNguoiDung.vue?vue&type=template&id=8e4746c4&"
import script from "./QuanLyThongTinNguoiDung.vue?vue&type=script&lang=js&"
export * from "./QuanLyThongTinNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports